import { startOfToday } from "date-fns";
import { createDomain } from 'effector';

import {
    ApiResponse,
    TransactionListSort,
    TransactionListStore,
    TransactionsListSortTypes,
    GetTransactionsArgs,
    SortOrder,
    POSTransaction,
    GetPlaybackTransactionsArgs,
    GetTimelineTransactionsArgs,
    GetPlaybackTransactionsResponse,
    GetNewTransactionTimeArgs,
    GetNewTransactionTimeResponse,
    ITransactionsListFilters,
    SiteData,
    DeviceMiniInfo,
    PosTooltip,
    TransactionDisplayType,
} from "../../stores/types.ts";

export const rootDomain = createDomain('rootDomain');
const transactionsDomain = rootDomain.createDomain('transactionsDomain');

export const $transactionsStore = transactionsDomain.createStore<TransactionListStore>({
    type: TransactionsListSortTypes.createdAt,
    direction: SortOrder.DESC,
    transactions: [],
    pagesCount: 1,
    page: 1,
});

export const resetTransactionsStore = transactionsDomain.createEvent();
$transactionsStore.reset(resetTransactionsStore);

export const $transactionsListSearchValue = transactionsDomain.createStore<string>('');
export const setSearchValue = transactionsDomain.createEvent<string>();

export const $transactionsListFilters = transactionsDomain.createStore<ITransactionsListFilters>({
    selectedSite: null,
    selectedPOS: null,
    startDate: null,
    endDate: null,
    startTime: undefined,
    endTime: undefined,
});

export const setSelectedSite = transactionsDomain.createEvent<SiteData | null>();
export const setSelectedPOS = transactionsDomain.createEvent<DeviceMiniInfo | null>();
export const setDateFilters = transactionsDomain.createEvent<[Date | null, Date | null]>();
export const setStartTimeFilter = transactionsDomain.createEvent<{ startTime: string | undefined }>();
export const setEndTimeFilter = transactionsDomain.createEvent<{ endTime: string | undefined }>();

export const getTransactionsFx = transactionsDomain.createEffect<
    GetTransactionsArgs,
    ApiResponse<{ transactions: POSTransaction[], pagesCount: number }>
>("getTransactionsFx");

export const updateTransactionListSortEvent =
    transactionsDomain.createEvent<TransactionListSort>("updateTransactionListSortStoreEvent");

export const setTransactionsPage = transactionsDomain.createEvent<number>();

export const $liveVideoTransactions = transactionsDomain.createStore<Record<string, Record<string, POSTransaction>>>({});

export const clearLiveTransactions = transactionsDomain.createEvent<string>();

export const $playbackTransactions = transactionsDomain.createStore<POSTransaction[]>([]);
export const resetPlaybackTransactions = transactionsDomain.createEvent();
$playbackTransactions.reset(resetPlaybackTransactions);

export const getPlaybackTransactionsFx = transactionsDomain.createEffect<GetPlaybackTransactionsArgs, ApiResponse<GetPlaybackTransactionsResponse>>("getPlaybackTransactionsFx");

export const setLiveTransaction = transactionsDomain.createEvent<{ transaction: POSTransaction }>();

export const $timelineTransactions = transactionsDomain.createStore<POSTransaction[]>([]);
export const $longTimelineDayStart = transactionsDomain.createStore<Date>(startOfToday());

export const getTimelineTransactionsFx = transactionsDomain.createEffect<GetTimelineTransactionsArgs, ApiResponse<GetPlaybackTransactionsResponse> | undefined>("getTimelineTransactionsFx");

export const resetTimelineTransactions = transactionsDomain.createEvent();
$timelineTransactions.reset(resetTimelineTransactions);
$longTimelineDayStart.reset(resetTimelineTransactions);

export const getNewTransactionTimeFx = transactionsDomain.createEffect<GetNewTransactionTimeArgs, ApiResponse<GetNewTransactionTimeResponse>>("getNewTransactionTimeFx");

export const $posNameTooltipInfo = transactionsDomain.createStore<PosTooltip | null>(null);
export const setPosNameTooltipInfo = transactionsDomain.createEvent<PosTooltip | null>();

export const $transactionsDisplayType = transactionsDomain.createStore<TransactionDisplayType>(TransactionDisplayType.TABLE);
export const setTransactionsDisplayType = transactionsDomain.createEvent<TransactionDisplayType>();
